// Shared must-haves shape resolver — the ONLY place that should ever read the
// raw must-haves fields off a style profile. Accepts BOTH shapes:
//   • legacy flat `video.must_haves[]` — treated as the Highlight list
//   • 2026-07 split `video.must_haves_by_category` = { highlight, doc_edit, social }
// Defensive by contract: missing/undefined/malformed data resolves to [] — never throws.

// Client-side mirror of the server's _project_category resolver. The server also says its own answer on the project
// as `edit_category`, and that wins: an editor's copy carries no line items (its prices are taken off), and read from
// line items alone every one of their projects looked like a highlight film.
export function resolveProjectCategory(project) {
  if (project && project.edit_category) return project.edit_category;
  const li = ((project && project.line_items) || [])[0] || {};
  if (li.is_doc_edit) return 'doc_edit';
  if ((li.label || '').startsWith('Social Media Video')) return 'social';
  return 'highlight';
}

export const MUST_HAVE_CATEGORY_LABELS = {
  highlight: 'Highlight Videos',
  doc_edit: 'Doc Edits',
  social: 'Social Media Videos',
};

// Returns the list for ONE category, tolerating either profile shape.
export function mustHavesForCategory(video, category) {
  const v = video || {};
  const byCat = v.must_haves_by_category;
  if (byCat && typeof byCat === 'object') {
    return Array.isArray(byCat[category]) ? byCat[category] : [];
  }
  // Legacy flat array = the highlight list; other categories are empty.
  return category === 'highlight' && Array.isArray(v.must_haves) ? v.must_haves : [];
}

// Resolve the list that applies to a specific project.
export function resolveMustHaves(video, project) {
  const category = resolveProjectCategory(project);
  return { category, items: mustHavesForCategory(video, category) };
}

// Fresh empty new-shape structure (e.g. wizard seed for brand-new profiles).
export function emptyMustHavesByCategory() {
  return { highlight: [], doc_edit: [], social: [] };
}

// Minimal `video` stub carrying an empty new-shape structure — keeps even the
// raw field NAME out of consumer code (wizard first-time authoring seed).
export function emptyMustHavesVideoSeed() {
  return { must_haves_by_category: emptyMustHavesByCategory() };
}
